import { useEffect, useState } from "react";
import { useAppSelector } from "../../redux/hooks";
import { selectFeaturePermissions } from "../../redux/selectors/loginSelector";
import { PermissionsProps, SubModuleProps } from "../../components/AccessManagement/PermissionProps";

export const usePermissionGetter = (
  moduleName: string,
  featureName: string
) => {
  const [module, setModule] = useState<SubModuleProps>({});
  const [feature, setFeature] = useState<PermissionsProps>({});
  const [userPermission,setUserPermission] = useState<PermissionsProps>({
    create:false,
    read:false,
    update:false,
    download:false,
    export:false
  })
  const [hasModulePermission,setHasModulePermisison]= useState<boolean>(false)

  const featurePermissions = useAppSelector(selectFeaturePermissions);

  useEffect(() => {
    if (featurePermissions) {
      const module = featurePermissions[moduleName];
      setModule(module);
      if (module) {
        setHasModulePermisison(true);
        setFeature(module[featureName]);
      }
    }
  }, [featurePermissions]);

  useEffect(() => {
    feature && setUserPermission(feature)
  }, [feature]);

  const getUserPermission = (permission: keyof PermissionsProps) => {
    if (!module) return false;
    if (!feature) return false;

    return feature[permission];
  };

  return { getUserPermission, userPermission, hasModulePermission };
};
